import {MetaTitleDesc} from "../meta";
import DocumentMeta from "react-document-meta";

export default () => {
    const title = 'Паровые краны';

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <h3>Паровой кран ПК ЦУМ315 490</h3>
                    <p>ПК ЦУМ315 №490</p>
                    <p>На железнодорожном ходу</p>
                    <p>Грузоподъемность 15т</p>
                    <p>Общая масса крана в рабочем состоянии - 55т</p>
                    <p>Вылет стрелы - 14м</p>
                    <p>Высота подъема груза - 13,8т</p>
                    <p>Скорость подъема груза - 11м/мин</p>
                    <p>Емкость грейфера - 1,5м3</p>
                </div>
                <div className="three-col-cell gallery"><img src={require('./../img/virtualtours/museumlocomotive/mzt066.jpg')} /></div>
                <div className="three-col-cell gallery"><img src={require('./../img/virtualtours/museumlocomotive/mzt067.jpg')} /></div>

                <div className="pageitem">
                    <h3>Паровой кран ПК-6 1158</h3>
                    <p>ПК-6 №1158</p>
                    <p>На железнодорожном ходу</p>
                    <p>Грузоподъемность 6т</p>
                    <p>Общая масса крана в рабочем состоянии - 34т</p>
                    <p>Вылет стрелы: наибольший 10м</p>
                    <p>Вылет стрелы: наименьший 5м</p>
                    <p>Наибольшая высота подъема груза - 10,3т</p>
                    <p>Емкость грейфера - 1,5м3 Скорость подъема груза: краном - 12м/мин</p>
                    <p>Скорость подъема груза: грейфером - 24м/мин</p>
                </div>
                <div className="three-col-cell gallery"><img src={require('./../img/virtualtours/museumlocomotive/mzt068.jpg')} /></div>
            </div>
        </>
    );
}